import {
  DocumentAnyData,
  PreviousDocument,
  SupportingDocument,
  TransportDocument,
} from 'features/declaration/models/schemas/documentSchemas'
import {
  HouseConsignmentFormValues,
  HouseConsignmentData,
} from 'features/declaration/house-consignment/models/schema'
import { excludeDeleted } from 'shared/lib/common-util'
import createDocumentSaver from '../../document/components/createDocumentSaver'
import { toDocumentSaveBatch } from '../../document/models/formValuesToModel'
import resequenceDocuments from '../../document/models/resequence'
import { createHouseConsignmentDocuments } from '../api/createHouseConsignmentDocuments'
import { updateHouseConsignmentDocuments } from '../api/updateHouseConsignmentDocuments'

function getDocumentFromForm(formValues: HouseConsignmentData): DocumentAnyData[] {
  const existingTransportDocuments: TransportDocument[] = resequenceDocuments(formValues.transportDocument.filter(excludeDeleted))
  const existingPreviousDocuments: PreviousDocument[] = resequenceDocuments(formValues.previousDocument.filter(excludeDeleted))
  const existingSupportingDocuments: SupportingDocument[] = resequenceDocuments(formValues.supportingDocument.filter(excludeDeleted))

  return [
    ...existingTransportDocuments,
    ...existingPreviousDocuments,
    ...existingSupportingDocuments,
  ] as DocumentAnyData[]
}

export default function useSaveHouseConsignmentDocuments(transitOperationId: number) {
  const saveHouseConsignmentDocuments = (
    houseConsignmentId: number,
    formValues: HouseConsignmentFormValues,
  ) => {
    const saveDocuments = createDocumentSaver({
      createDocumentsFn: (documents) => createHouseConsignmentDocuments(transitOperationId, houseConsignmentId, documents),
      updateDocumentsFn: (documents) => updateHouseConsignmentDocuments(transitOperationId, houseConsignmentId, documents),
    })

    const documents = toDocumentSaveBatch(getDocumentFromForm(formValues))

    return saveDocuments(documents)
  }

  return { saveHouseConsignmentDocuments }
}
